<template>
  <footer>
    <!-- <div class="col-lg-12 footerDiv">
      <ul class="footerList">
        <li><a href="https://turasistan.com/yardim">{{ $t('footer.support') }}</a></li>
        <li><a href="https://turasistan.com/sikca-sorulan-sorular">{{ $t('footer.faq') }}</a></li>
        <li><a href="https://turasistan.com/kullanim-klavuzu">{{ $t('footer.guide') }}</a></li>
        <li><a href="https://turasistan.com/gelistirici">{{ $t('footer.api') }}</a></li>
        <li><a href="https://www.turasistan.com/"
               class="footerLogo"
               target="_blank" /></li>
        <li><a href="https://www.facebook.com/turasistan">{{ $t('footer.facebook') }}</a></li>
        <li><a href="https://www.instagram.com/turasistan/">{{ $t('footer.instagram') }}</a></li>
        <li><a href="https://turasistan.com/blog">{{ $t('footer.blog') }}</a></li>
        <li><a href="https://turasistan.com/bize-ulasin">{{ $t('footer.contact') }}</a></li>
      </ul> -->
    <!-- @turasistan. Powered By <a href="http://sanalogi.com"
                          target="_blank">Sanalogi</a>
                           -->
    <!-- </div> -->
  </footer>
</template>

<script>
export default {
	name: 'app-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/footer/index.vue